module.exports = __webpack_public_path__ + "img/唐钢中厚板.66648364.png";